<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>ADD - FARM MANAGEMENT</h2>
          <p>Create Farm record</p>
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <form class="row" [formGroup]="registerForm">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Farm Name</label>
            <input type="text" name="adddose" id="farmname" value="" formControlName="farmname" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.farmname.errors }">
            <div *ngIf="submitted && f.farmname.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.farmname.errors.required">Farm Name must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group form-group">
            <label for="Note">Farm Id</label>
            <input type="text" name="farmid" id="farmid" value="" formControlName="farmid" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.farmid.errors }">
            <div *ngIf="submitted && f.farmid.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.farmid.errors.required">Farm ID must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Note">Contact Person</label>
            <input type="text" id="farmcontactname" formControlName="farmcontactname" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.farmcontactname.errors }">
            <div *ngIf="submitted && f.farmcontactname.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.farmcontactname.errors.required">Contact Person Name must be filled
                out</div>
              <div class="selectvalidate" *ngIf="f.farmcontactname.errors.pattern">Contact person name must be
                alphabetic only</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Note">Contact Email</label>
            <input type="email" id="farmcontactemail" formControlName="email" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.email.errors.required">Contact Email must be filled out</div>
              <div class="selectvalidate" *ngIf="f.email.errors.email">Email must be a valid email address</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Note">Contact Number</label>
            <input type="text" formControlName="mobileNumber" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }" id="ContactNumber">
            <div *ngIf="submitted && f.mobileNumber.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.mobileNumber.errors.required">Contact Number must be filled out</div>
              <div class="selectvalidate" *ngIf="f.mobileNumber.errors.pattern">Please, Enter 10 digit Mobile Number.
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group ">
            <label for="Note">Address</label>
            <input type="text" formControlName="Address" class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.Address.errors }" id="Address">
            <div *ngIf="submitted && f.Address.errors" class="invalid-feedback">
              <div class="selectvalidate" *ngIf="f.Address.errors.required">Address must be filled out</div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <a (click)="onSubmit()" class="btn btn-fill btn-primary mb-3">Submit
            <div class="ripple-container"></div>
          </a>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
            </button>
        </div>
      </form>
    </div>
  </div>
</div>